import { atom } from 'recoil'

export const isLoadingState = atom({
  key: 'isLoadingHomeState',
  default: false
})
